
import {
  getFiveDetails,
  getSixDetails,
  getBasics,
  getAmountSummary
} from '@/api/office'

const state = {
}

const mutations = {
}

const actions = {
// R06-获取施工交付方案详情
  getFiveDetails(temp, data) {
    return new Promise((resolve, reject) => {
      getFiveDetails(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // R07-获取增值服务方案详情
  getSixDetails(temp, data) {
    return new Promise((resolve, reject) => {
      getSixDetails(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // R09-获取报价详情
  getBasics(temp, data) {
    return new Promise((resolve, reject) => {
      getBasics(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // R10-获取报价金额汇总
  getAmountSummary(temp, data) {
    return new Promise((resolve, reject) => {
      getAmountSummary(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
